<template>
  <v-tooltip bottom color="black" max-width="300px">
    <template v-slot:activator="{ on, attrs }">
      <div
        class="max__width__text"
        :style="{ 'max-width': maxWidth }"
        v-bind="attrs"
        v-on="on"
      >
        {{ resource }}
      </div>
    </template>
    <span>{{ resource }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
    },

    maxWidth: {
      type: String,
      default: "150px",
    },
  },
};
</script>

<style lang="scss">
.max__width__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
}
</style>
